import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import menus from '../libs/menu'
import NProgress from 'nprogress/nprogress'

Vue.use(VueRouter)

let children = []

menus.forEach(menu => {
    if (menu.path) {
        children.push(menu2route(menu))
    }
    if (menu.subs && menu.subs.length > 0) {
        menu.subs.forEach(sub => {
            if (sub.path) {
                children.push(menu2route(sub))
            }
        })
    }
})

// 转换菜单对象到路由策略
function menu2route(menu) {
    return {
        path: menu.path,
        name: menu.code,
        meta: {
            role: menu.role
        },
        component: () => import('../views/' + menu.comp)
    }
}

const routers = {
    routes: [
        {
            path: '/login',
            name: 'guest.login',
            component: () => import('../views/Login.vue')
        },
        {
            path: '/',
            redirect: '/index',
            name: 'ui.main',
            meta: {
                role: 'auth'
            },
            component: () => import('../views/Main.vue'),
            children: children
        },
        {
            path: '/*',
            name: 'ui.404',
            component: () => import('../views/404.vue')
        }
    ]
}

const router = new VueRouter(routers)

const hasRole = function(role) {
    let user = store.state.User
    if (!user || (!user.role && !user.type)) {
        return false
    }
    if (role && user.type && role.toLowerCase().startsWith(user.type.toLowerCase())) {
        return true
    }
    if (role && user.role && role.toLowerCase() === user.role.toLowerCase()) {
        return true
    }
    return false
}

router.beforeEach((to, from, next) => {
    if (from && from.name) {
        NProgress.start()
    }
    if (to.meta.role) {
        let token = store.state.User.token
        if (token === null || token === undefined || token === '') {
            store.commit('signout')
            next({
                name: 'guest.login'
            })
        } else if (to.meta.role !== 'auth') {
            let flg = false
            if (to.meta.role.indexOf(',') >= 0) {
                for (let role of to.meta.role.split(',')) {
                    flg = hasRole(role)
                    if (flg) break
                }
            } else {
                flg = hasRole(to.meta.role)
            }

            if (!flg) {
                next({
                    name: 'ui.403'
                })
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        store.commit('signout')
        next()
    }
})

router.afterEach(() => {
    // pass
    NProgress.done()
})

export default router
